/**
 * Card Fleet Ops route guard.
 *
 * The fleet lives inside the Command Center for restaurant tenants, and for a
 * super admin whose CURRENT Command Center scope is a restaurant org/location.
 * Those callers are sent to the block (scrolled to it) so old links and
 * bookmarks keep working; everyone else gets the standalone page, unchanged.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { fleetLivesInCommandCenter } from '../lib/vertical';
import CardFleetOps from './CardFleetOps';

export default function CardFleetOpsRoute() {
    const { user } = useAuth();
    if (fleetLivesInCommandCenter(user)) {
        return <Navigate to="/command-center?focus=fleet" replace />;
    }
    return <CardFleetOps />;
}
